(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/radio/campaign.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/radio/campaign.js');

'use strict';

const _svs$numbergames$camp = svs.numbergames.campaign,
  asyncCampaignApi = _svs$numbergames$camp.asyncCampaignApi,
  asyncOpenCampaignApi = _svs$numbergames$camp.asyncOpenCampaignApi,
  CAMPAIGN_CONSTANTS = _svs$numbergames$camp.CONSTANTS;
svs.numbergames.results.radio.campaign = Backbone.Radio.channel('campaign');
svs.numbergames.results.radio.campaign.reply('campaign', async _ref => {
  let productId = _ref.productId,
    date = _ref.date;
  const drawTypeId = CAMPAIGN_CONSTANTS.DRAW_TYPE.CAMPAIGN;
  const campaignByDate = await asyncCampaignApi.getCampaign(productId, {
    date,
    drawTypeId
  });
  if (campaignByDate) {
    return campaignByDate;
  }
  const openCampaign = await asyncOpenCampaignApi.getCampaign(productId, {
    drawTypeId
  });
  if (openCampaign) {
    return openCampaign;
  }
  const today = new Date(svs.numbergames.data.results.todayDateString);
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);
  const endDateInterval = {
    start: sevenDaysAgo,
    end: today
  };
  if (dateFns.isWithinInterval(new Date(date), endDateInterval)) {
    const recentlyClosedCampaign = await asyncCampaignApi.getCampaign(productId, {
      endDateInterval,
      drawTypeId
    });
    if (recentlyClosedCampaign) {
      return recentlyClosedCampaign;
    }
  }
});

 })(window);